import { Slide, Zoom } from "react-reveal";
import abcd from "../../assets/images/testimonials/abcd.jpg";
import agma from "../../assets/images/testimonials/agma.jpg";
import aykonik from "../../assets/images/testimonials/aykonik.jpg";
import amaph from "../../assets/images/testimonials/amaph.jpg";
import brandcare from "../../assets/images/testimonials/brandcare.jpg";
import burrow from "../../assets/images/testimonials/burrow.svg";
import citylink from "../../assets/images/testimonials/citylink.png";
import cmc from "../../assets/images/testimonials/cmc.png";
import dda from "../../assets/images/testimonials/dda.jpg";
import elka from "../../assets/images/testimonials/elka.png";
import hk9 from "../../assets/images/testimonials/habibk9.png";
import malidad from "../../assets/images/testimonials/malidad.png";
import myfloat from "../../assets/images/testimonials/myfloatpay.jpg";
import negash from "../../assets/images/testimonials/negash.png";
import nexus from "../../assets/images/testimonials/nexus.jpg";
import nexushosp from "../../assets/images/testimonials/nexushosp.jpg";
import nmau from "../../assets/images/testimonials/nmau.png";
import sda from "../../assets/images/testimonials/sda.jpg";
import taneem from "../../assets/images/testimonials/taneem.png";
import waveney from "../../assets/images/testimonials/waveney.png";
import aypfarm from "../../assets/images/testimonials/aypoultryfarm.jpg";
import bluetides from "../../assets/images/testimonials/bluetides.png";
import dylan from "../../assets/images/testimonials/dylan.png";
import arasus from "../../assets/images/testimonials/arasus.jpg";
import gfarm from "../../assets/images/testimonials/habibfarm.png";
import gk9 from "../../assets/images/testimonials/habibk9.png";
import kcg from "../../assets/images/testimonials/kcg.png";
import charity from "../../assets/images/testimonials/charitywater.jpg";
import kambo from "../../assets/images/testimonials/kambo.png";
import ui from "../../assets/images/testimonials/ui.jpg";
import jmstone from "../../assets/images/testimonials/jmstone.png";
import twin from "../../assets/images/testimonials/twintower.png";

const ClientsBody = () => {
  return (
    <section className="clients section-spacing-100">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="section-head center width-600 margin-auto section-spacing-50 no-padding-top">
              <p className="section-tag boldTitle">some of our CLIENTS</p>
              <Slide top>
                <h2 className="section-title ntuna-text-fill">
                  Trusted by Leading Organizations Across Industries
                </h2>
              </Slide>
            </div>
            <div className="section-body width-960 margin-auto">
              <div className="trust-container">
                <Zoom>
                  <img src={burrow} alt="Burrow" />
                </Zoom>
                <Zoom delay={500}>
                  <img src={cmc} alt="Corporate Muslim Community" />
                </Zoom>
                <Zoom delay={600}>
                  <img src={waveney} alt="Waveney Courts" />
                </Zoom>
                <Zoom delay={700}>
                  <img src={brandcare} alt="Brand Care" />
                </Zoom>
                <Zoom delay={800}>
                  <img src={myfloat} alt="My Float Pay" />
                </Zoom>
                <Zoom delay={900}>
                  <img src={arasus} alt="Arasus Aviation" />
                </Zoom>
                <Zoom delay={1000}>
                  <img src={bluetides} alt="Bluetides Uganda Limited" />
                </Zoom>
                <Zoom delay={1100}>
                  <img src={kambo} alt="Kambo Autos" />
                </Zoom>
                <Zoom delay={1200}>
                  <img src={dylan} alt="Dylan Medical Services" />
                </Zoom>
                <Zoom delay={1300}>
                  <img src={amaph} alt="Amaph Initiative Africa" />
                </Zoom>
                <Zoom delay={1400}>
                  <img src={twin} alt="Twin Tower Hotel" />
                </Zoom>
                <Zoom delay={1500}>
                  <img src={citylink} alt="City Link cabs" />
                </Zoom>
                <Zoom delay={1600}>
                  <img src={sda} alt="Single Dollar Appeal Uganda" />
                </Zoom>
                <Zoom delay={1700}>
                  <img
                    src={nmau}
                    alt="National Midwives Association of Uganda"
                  />
                </Zoom>

                <Zoom delay={1800}>
                  <img src={abcd} alt="The ABCD Company" />
                </Zoom>
                <Zoom delay={1900}>
                  <img src={gk9} alt="Great Habib K9 Academy" />
                </Zoom>
                <Zoom delay={500}>
                  <img src={jmstone} alt="Jmstone Logistics" />
                </Zoom>
                <Zoom delay={600}>
                  <img src={charity} alt="Charity Water Organization" />
                </Zoom>
                <Zoom delay={700}>
                  <img src={kcg} alt="Kampala City Grammar School" />
                </Zoom>
                <Zoom delay={800}>
                  <img src={gfarm} alt="Great Habib Smart Farm Academy" />
                </Zoom>
                <Zoom delay={900}>
                  <img src={ui} alt="Upcountry Investors" />
                </Zoom>
                <Zoom delay={1000}>
                  <img src={aypfarm} alt="AY Poultry Farm" />
                </Zoom>
                <Zoom delay={1100}>
                  <img src={agma} alt="AY Gold Mountain Academy" />
                </Zoom>
                <Zoom delay={1200}>
                  <img src={aykonik} alt="Aykonik Construction Company" />
                </Zoom>

                <Zoom delay={1300}>
                  <img src={dda} alt="Destination Delights Africa" />
                </Zoom>
                <Zoom delay={1400}>
                  <img src={elka} alt="Elka Center" />
                </Zoom>
                <Zoom delay={1500}>
                  <img src={hk9} alt="Great Habib K9 Academy" />
                </Zoom>
                <Zoom delay={1600}>
                  <img src={malidad} alt="MALIDAD.COM" />
                </Zoom>

                <Zoom delay={1700}>
                  <img src={negash} alt="Negash Construction Company" />
                </Zoom>
                <Zoom delay={1800}>
                  <img src={nexus} alt="Nexus Events" />
                </Zoom>
                <Zoom delay={1900}>
                  <img src={nexushosp} alt="Nexus Hospitality" />
                </Zoom>

                <Zoom delay={2000}>
                  <img src={taneem} alt="Taneem Charity Organization" />
                </Zoom>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientsBody;
